import React, { useEffect,useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./Profilesub.css";
import { gettoastwarning,gettoastsuccess } from '../../Utils/Common';
import {validateprofile} from '../../Utils/validate';
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';

const Profilesub = () => {
  const [loading,setLoading] = useState(true);
  const [errors,setErrors] = useState({});

  const [inputs,setInputs] = useState({first_name:'',middel_name:'',last_name:'',cell_phone:'',company_email:'',personal_email:'',address:'',city_or_state:'',zipcode:'',country:'',new_password:'',confirm_password:''});
  const [image, setImage] = useState({preview: '', raw: ''});

  const [country,setCountry] = useState([]);
  //const [level,setLevel] = useState([]);
  //const [dept,setDept] = useState([]);

  useEffect(() => {
    document.title = `create-account | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";
    
     /* Start get profile */
  let formData1 = new FormData(); 
    formData1.append('token', localStorage.getItem("token"));
    API.post('backoffice_get_user_detail', formData1)
      .then(response => {
   setLoading(false);
      if(response.data.status ===1){
          setInputs({
            first_name:response.data.data.first_name,
            middel_name:response.data.data.middel_name,
            last_name:response.data.data.last_name,
            cell_phone:response.data.data.cell_phone,
            company_email:response.data.data.company_email,
            personal_email:response.data.data.personal_email,
            address:response.data.data.address,
            city_or_state:response.data.data.city_or_state,
            zipcode:response.data.data.zipcode,
            country:response.data.data.country
          });

          setImage({preview:response.data.data.profile, raw: ''});
      }                
    }).catch(error => {
       setLoading(false);
    });  
   /* End get profile */


    /* Start get country */
    API.get('backoffice_country')
      .then(response => {
        
      if(response.data.status === 0){
        
      }else{
        setCountry(response.data.data);
      }                  
    }).catch(error => {
       
    });  
  /* End get country */



  }, []);

/* Start Value set */
const handleInputChange = (event) => {
  event.persist();
  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
/* End Value set */
/* Start image set */
const handleChangeImg = (event) => {
  event.preventDefault();
  if (!event.target.files[0].name.match(/\.(jpg|jpeg|png|gif)$/)) {
    gettoastwarning('Please select valid image.','');
  }else{
      setImage({
      preview: URL.createObjectURL(event.target.files[0]),
      raw: event.target.files[0]
    });
  }
}
/* Start image set */
//Start Login check
const handleSubmit = (event) => {
  event.preventDefault();
  const validationErrors = validateprofile(inputs,image);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){
      setLoading(true);
      const token = localStorage.getItem('token'); 

        let formData = new FormData(); 
        formData.append('token', token);
      Object.keys(inputs).forEach((key) => {
          formData.append(key, inputs[key]);
      });
      if(image.raw!=='')
      {
        formData.append('profile', image.raw);
      }
      API.post('backoffice_profile_update', formData)
                .then(response => {
                  setLoading(false);
                if(response.data.status === 1){
                    gettoastsuccess(response.data.message,'/profile-sub');
                }else{
                    gettoastwarning(response.data.message,'');
                     
                }
              }).catch(error => {
                  setLoading(false);
                  gettoastwarning("Something went wrong. Please try again later.",'');
          }); 
      }
  }



  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-md-12 col-lg-9 holisti okhas">
                    <h1>Profile</h1>
                    <div className="accou-card">
                      <div className="row g-2 g-md-3">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">First name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First name"
                            name="first_name"
                            value={inputs.first_name}
                            onChange={handleInputChange}
                          />
                          {errors.first_name && (<p className="text-danger text-start mb-0">{errors.first_name}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Middle Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Middle name"
                            name="middel_name"
                            value={inputs.middel_name}
                          onChange={handleInputChange}
                          />
                          {errors.middel_name && (<p className="text-danger text-start mb-0">{errors.middel_name}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Last name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last name"
                            name="last_name"
                            value={inputs.last_name}
                            onChange={handleInputChange}
                          />
                          {errors.last_name && (<p className="text-danger text-start mb-0">{errors.last_name}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label htmlFor="fileUpload" className="form-label">Upload your picture</label>
                          <div className="row">
                            <div className="col-10">
                              <input
                                type="file"
                                id="fileUpload"
                                className="form-control w-100"
                                accept="image/*"
                                onChange={handleChangeImg}
                              />
                              {errors.profile && (<p className="text-danger text-start mb-0">{errors.profile}</p>)}
                            </div>
                            <div className="col-2">
                              {image.preview ? (
                                  <> 
                              <img src={image.preview} id="imagePreview" className="img-fluid img-mer-pro" alt="Logo"/>
                              </>
                              ) : null}
                            </div>
                        </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Cell phone</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter phone number"
                            name="cell_phone"
                            onChange={handleInputChange} value={inputs.cell_phone}
                          />
                          {errors.cell_phone && (<p className="text-danger text-start mb-0">{errors.cell_phone}</p>)}
                        </div>
                        
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">
                            Company Email address
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Email address"
                            name="company_email"
                            onChange={handleInputChange} value={inputs.company_email}
                          />
                          {errors.company_email && (<p className="text-danger text-start mb-0">{errors.company_email}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">
                            Personal Email address
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Email address"
                            name="personal_email"
                            onChange={handleInputChange} value={inputs.personal_email}
                          />
                          {errors.personal_email && (<p className="text-danger text-start mb-0">{errors.personal_email}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">
                            Mailing Address - No., Street
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            name="address"
                            onChange={handleInputChange} value={inputs.address}
                          />
                          {errors.address && (<p className="text-danger text-start mb-0">{errors.address}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">City, State</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="City, State"
                            name="city_or_state"
                            onChange={handleInputChange} value={inputs.city_or_state}
                          />
                          {errors.city_or_state && (<p className="text-danger text-start mb-0">{errors.city_or_state}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Zip Code</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Zip code"
                            name="zipcode"
                            onChange={handleInputChange} value={inputs.zipcode}
                          />
                          {errors.zipcode && (<p className="text-danger text-start mb-0">{errors.zipcode}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Country</label>
                          <select className="form-select" name="country" onChange={handleInputChange} value={inputs.country}>
                            <option value="">Select Country</option>
                            {country && country.map((val,index) => {
                                      return(
                                          <option value={val.id} key={index}>{val.name}</option>
                                      )
                                  })}
                          </select>
                          {errors.country && (<p className="text-danger text-start mb-0">{errors.country}</p>)}
                        </div>
                        
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                          <label className="form-label">New Password</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="New Password"
                            name="new_password" onChange={handleInputChange} value={inputs.new_password}
                          />
                          {errors.new_password && (<p className="text-danger text-start mb-0">{errors.new_password}</p>)}
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4">
                          <label className="form-label">Confirm Password</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Confirm Password"
                            name="confirm_password" onChange={handleInputChange} value={inputs.confirm_password}
                          />
                          {errors.confirm_password && (<p className="text-danger text-start mb-0">{errors.confirm_password}</p>)}
                        </div>
                        <div className="col-12">
                          <div className="mt-3">
                            <button type="button" className="submit-btn" onClick={handleSubmit}>Edit account</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
           <div className="loadingClass">
            <img src={loader} alt="loader"/>
          </div>
           )}  
    </>
  );
};

export default Profilesub;
